const endpoints = {
  auth: {
    login: "/admin-panel/login",
    logout: "/users/logout",
    refreshToken: "/users/refresh-token",
    resetpassword: "/admin-panel/forgot-password/reset",
    sendotp: "/admin-panel/forgot-password/send-otp",
    verifyotp: "/admin-panel/forgot-password/verify-otp",
  },
  changePassword: {
    sendOtp: "/admin-panel/change-password/send-otp",
    verifyOtp: "/admin-panel/change-password/verify-otp",
    reset: "/admin-panel/change-password/reset",
  },
  admin: {
    userList: "/admin/user-list",
    createUser: "/admin/user-list",
    updateUser: "/admin/user-detail/{user_id}",
    deleteUser: "/admin/user-detail/{user_id}",
    sendlink: "/user/user-chat-link-send/{user_id}",
    userDetail: "/admin/user-detail/{user_id}",
    sendMailBroker: "/admin/send-email-to-broker",
    downloadPdf: "/admin/user-download/{user_id}",
  },
  adminEvents: {
    list: "/vendors/events/",
    detail: (id) => `/vendors/events/${id}/`,
    listByEvent: (eventId) => `/admin-panel/bookings/booking-list`,
    updateStatus: (id) => `/admin-panel/events/${id}/status/`,
    export: "/vendors/events/",
    bookingDetail: (id) => `/admin-panel/bookings/booking-detail/${id}`,
    downloadTicket: (id) => `/admin-panel/bookings/booking-detail/${id}/ticket`,
    downloadInvoice: (id) =>
      `/admin-panel/bookings/booking-detail/${id}/invoice`,
  },
  eventmanagement: {
    categorylist: "/vendors/events/categories/",
    subcategorylist: (id) => `/vendors/events/categories/${id}/subcategories/`,
    createEvent: "/vendors/events/",
    eventDetail: (id) => `/vendors/events/${id}/`,
    eventUpdate: (id) => `/vendors/events/${id}/`,
    updateStatus: (id) => `/admin-panel/events/${id}/status/`,
    cancelSchedule: (id) => `/admin-panel/events/${id}/schedules/cancel/`,
    amenities: "/vendors/events/amenities/",
    ticektTypes: "/vendors/events/ticket-types/",
    history: (eventId) => `/history/event/${eventId}`,
  },
  location: {
    countries: "/users/countries",
    states: (countryId) => `/users/states/${countryId}`,
    cities: (countryId, stateId) =>
      `/users/cities/${countryId}?state_id=${stateId}`,
  },
  setting: {
    languageslist: "/users/languages",
    currencieslist: "/users/currencies",
    preferences: "/vendors/preferences/",
    updatepreferences: "/vendors/preferences/",
  },

  user: {
    chatUser: "/user/user-chat/{token}",
  },
  flight: {
    dashboard: "/admin-panel/bookings/dashboard",
    list: "/admin-panel/bookings/booking-list",
    detail: (id) => `/admin-panel/bookings/booking-detail/${id}`,
  },
  carRental: {
    list: "/admin-panel/bookings/booking-list",
    dashboard: "/admin-panel/bookings/dashboard",
    carRentialDetail: (id) =>
      `/admin-panel/bookings/booking-detail/${id}?booking_type=car`,
  },
  cruise: {
    list: "/admin-panel/bookings/booking-list",
    dashboard: "/admin-panel/bookings/dashboard",
    cruiseDetail: (id) =>
      `/admin-panel/bookings/booking-detail/${id}?booking_type=cruise`,
    cruisebooking: (id) => `/admin-panel/bookings/booking-detail/${id}`,
    ticket: (id, preview = false) =>
      `/admin-panel/bookings/booking-detail/${id}/ticket?preview=${preview}`,
    invoice: (id, preview = false) =>
      `/admin-panel/bookings/booking-detail/${id}/invoice?preview=${preview}`,
  },
  hotel: {
    dashboard: "/admin-panel/bookings/dashboard",
    list: "/admin-panel/bookings/booking-list",
    detail: (id) =>
      `/admin-panel/bookings/booking-detail/${id}?booking_type=hotel`,
  },

  venuebooking: {
    dashboard: "/admin-panel/bookings/dashboard",
    list: "/admin-panel/bookings/booking-list",
    detail: (id) =>
      `/admin-panel/bookings/booking-detail/${id}?booking_type=venue`,
  },

  notification: {
    list: "/notifications/",
    read: (id) => `/notifications/${id}/read/`,
    markAllRead: "/notifications/mark-all-read/",
    delete: (id) => `/notifications/${id}/delete/`,
  },
  rating: {
    rating: "/bookings/rating-summary",
    review: "/bookings/rating/review",
    reply: (id) => `bookings/rating/${id}/reply/`,
  },
  eventbooking: {
    dashboard: "/admin-panel/bookings/dashboard",
    list: "/admin-panel/bookings/booking-list",
    detail: (id) =>
      `/admin-panel/bookings/booking-detail/${id}?booking_type=event`,
  },

  allbooking: {
    list: "/admin-panel/bookings/booking-list",
    dashboard: "/admin-panel/bookings/dashboard",
  },
  avatar: {
    list: "/admin-panel/avatars",
    create: "/admin-panel/avatars/",
    stats: "/admin-panel/avatars/stats",
    detail: (id) => `/admin-panel/avatars/${id}`,
    update: (id) => `/admin-panel/avatars/${id}`,
    delete: (id) => `/admin-panel/avatars/${id}`,
  },
  userManagement: {
    dashboard: "/admin-panel/users/dashboard",
    list: "/admin-panel/users/list",
    overview: (userId) => `/admin-panel/users/overview/${userId}`,
    bookingSummary: (userId) => `/admin-panel/users/booking-summary/${userId}`,
    transaction: (userId) => `/admin-panel/users/transaction/${userId}`,
  },
  appOptions: {
    list: "/admin-panel/app-options/list",
  },
  banner: {
    list: "/admin-panel/banners/list",
    dashboard: "/admin-panel/banners/dashboard",
    create: "/admin-panel/banners/create",
    detail: (id) => `/admin-panel/banners/details/${id}`,
    update: (id) => `/admin-panel/banners/details/${id}`,
    delete: (id) => `/admin-panel/banners/details/${id}`,
  },
  video: {
    dashboard: "/admin-panel/influencers/video-dashboard",
    list: "/admin-panel/influencers/video-list",
    detail: (videoId) => `/admin-panel/influencers/video-detail/${videoId}`,
    delete: (videoId) => `/admin-panel/influencers/video-detail/${videoId}`,
    review: (videoId) => `/admin-panel/influencers/video-review/${videoId}`,
    influencersdashboard: "/admin-panel/influencers/dashboard",
    influencerslist: "/admin-panel/influencers/list",
    influencersDetail: (id) => `/admin-panel/influencers/detail/${id}`,
    influencersStatus: (id) => `/admin-panel/influencers/review/${id}`,
  },
  coupon: {
    list: "/coupons/",
    create: "/coupons/",
    analytics: "/coupons/analytics",
    stats: "/coupons/stats",
    detail: (id) => `/coupons/${id}`,
    update: (id) => `/coupons/${id}`,
    delete: (id) => `/vendors/coupons/${id}`,
    toggleStatus: (id) => `/coupons/${id}/toggle-status`,
  },
  eventcoupons: {
    create: "/vendors/coupons/",
    detail: (id) => `/vendors/coupons/${id}`,
    update: (id) => `/vendors/coupons/${id}`,
    delete: (id) => `/vendors/coupons/${id}`,
    toggleStatus: (id) => `/vendors/coupons/${id}/toggle-status`,
  },
  supportTicket: {
    list: "/admin-panel/tickets/",
    create: "/admin-panel/tickets/",
    stats: "/admin-panel/tickets/stats",
    detail: (id) => `/admin-panel/tickets/${id}`,
    update: (id) => `/admin-panel/tickets/${id}`,
  },
  subscription: {
    list: "/admin-panel/subscription/",
    create: "/admin-panel/subscription/",
    stats: "/admin-panel/subscription/stats",
    detail: (id) => `/admin-panel/subscription/${id}`,
    update: (id) => `/admin-panel/subscription/${id}`,
    delete: (id) => `/admin-panel/subscription/${id}`,
    invoice: (id) => `/admin-panel/subscription/payments/${id}/invoice`,
    subscribers: "/admin-panel/subscription/subscribers",
    subscriberStats: "/admin-panel/subscription/subscribers/stats",
    subscriberDetail: (id) => `/admin-panel/subscription/subscribers/${id}`,
  },
  priceLock: {
    airlines: "/admin-panel/price-lock/airlines",
    list: "/admin-panel/price-lock/configurations",
    create: "/admin-panel/price-lock/configurations",
    stats: "/admin-panel/price-lock/configurations/stats",
    detail: (id) => `/admin-panel/price-lock/configurations/${id}`,
    update: (id) => `/admin-panel/price-lock/configurations/${id}`,
    delete: (id) => `/admin-panel/price-lock/configurations/${id}`,
    toggleStatus: (id) =>
      `/admin-panel/price-lock/configurations/${id}/toggle-status`,
  },
  vendor: {
    dashboard: "/admin-panel/vendors/dashboard",
    list: "/admin-panel/vendors/list",
    detail: (vendorId) => `/admin-panel/vendors/detail/${vendorId}`,
    otherDetail: (vendorId) => `/admin-panel/vendors/other-detail/${vendorId}`,
    updateStatus: (vendorId) =>
      `/admin-panel/vendors/update-status/${vendorId}`,
    listingDetails: (listingId, vendorId) =>
      `/admin-panel/vendors/listing-detail/${listingId}/vendor/${vendorId}`,
    listingStatus: (listingId) =>
      `/admin-panel/vendors/listing-update-status/${listingId}`,
    listingDashboard: (vendorId) =>
      `/admin-panel/vendors/listing-dashboard/${vendorId}`,
    profileDetail: (vendorId) => `/vendors/profile/?vendor_id=${vendorId}`,
    profileUpdate: "/vendors/profile/",
    categoryOptions: "/admin-panel/app-options/list",
    vendorHistory: (vendorId) => `/history/vendor/${vendorId}`,
  },
  proposals: {
    list: "admin-panel/proposals/list",
    detail: (id) => `/admin-panel/proposals/${id}/detail`,
  },
  venue: {
    dashboard: "/admin-panel/venues/dashboard",
    list: "/admin-panel/venues/list",
    detail: (venueId) => `/admin-panel/venues/detail/${venueId}`,
    updateStatus: (venueId) => `/admin-panel/venues/update-status/${venueId}`,
    history: (venueId) => `/history/venue/${venueId}`,
  },

  location: {
    countries: "/users/countries",
    states: (countryId) => `/users/states/${countryId}`,
    cities: (countryId, stateId) =>
      `/users/cities/${countryId}?state_id=${stateId}`,
  },

  mylisting: {
    list: "/vendors/venues/listings/",
    stats: "/vendors/venues/stats/",
    listingDetailstats: (id) => `/vendors/venues/detail/${id}/stats/`,
    listingDetail: (id) => `/vendors/venues/detail/${id}/`,
    createlisting: "/vendors/venues/create/",
    vendorcategory: "/vendors/venues/categories/",
    amenities: "/vendors/venues/amenities/",
    updatelisting: (id) => `/vendors/venues/update/${id}/`,
    eventlisting: "/vendors/venues/events/",
  },

  blogAuthor: {
    create: "/admin-panel/blogs/author-create",
    dashboard: "/admin-panel/blogs/author-dashboard",
    list: "/admin-panel/blogs/author-list",
    update: (authorId) => `/admin-panel/blogs/author-details/${authorId}`,
    delete: (authorId) => `/admin-panel/blogs/author-details/${authorId}`,
    detail: (authorId) => `/admin-panel/blogs/author-details/${authorId}`,
  },
  blogCategory: {
    create: "/admin-panel/blogs/category-create",
    dashboard: "/admin-panel/blogs/category-dashboard",
    list: "/admin-panel/blogs/category-list",
    update: (categoryId) => `/admin-panel/blogs/category-details/${categoryId}`,
    delete: (categoryId) => `/admin-panel/blogs/category-details/${categoryId}`,
    detail: (categoryId) => `/admin-panel/blogs/category-details/${categoryId}`,
  },
  blog: {
    create: "/admin-panel/blogs/create",
    dashboard: "/admin-panel/blogs/dashboard",
    list: "/admin-panel/blogs/list",
    detail: (blogId) => `/admin-panel/blogs/view/${blogId}`,
    update: (blogId) => `/admin-panel/blogs/details/${blogId}`,
    delete: (blogId) => `/admin-panel/blogs/details/${blogId}`,
  },
  settings: {
    commissionList: "/admin-panel/settings/commission-list",
    commissionUpdateCreate: (module) =>
      `/admin-panel/settings/commission-update-create/${module}`,
    convenienceList: "/admin-panel/settings/convenience-list",
    convenienceUpdateCreate: (module) =>
      `/admin-panel/settings/convenience-update-create/${module}`,
  },
  faq: {
    list: "/admin-panel/faqs/",
    create: "/admin-panel/faqs/",
    detail: (faqId) => `/admin-panel/faqs/${faqId}`,
    update: (faqId) => `/admin-panel/faqs/${faqId}`,
    delete: (faqId) => `/admin-panel/faqs/${faqId}`,
  },
  privacyPolicy: {
    get: "/admin-panel/legal-content/privacy-policy",
    create: "/admin-panel/legal-content/privacy-policy",
    update: (policyId) =>
      `/admin-panel/legal-content/privacy-policy/${policyId}`,
  },
  termsAndConditions: {
    get: "/admin-panel/legal-content/terms-and-conditions",
    create: "/admin-panel/legal-content/terms-and-conditions",
    update: (termsId) =>
      `/admin-panel/legal-content/terms-and-conditions/${termsId}`,
  },
  hotelVendor: {
    list: "/vendors/hotel-portal/list",
    status: (hotelId) => `/hotels/admin/status/${hotelId}`,
    detail: (hotelId) => `/hotels/admin/detail/${hotelId}`,
    vendorDetail: (hotelId) => `/vendors/hotel-portal/details/${hotelId}`,
    cards: "/vendors/hotel-portal/cards",
    hotelHistory: (hotelId) => `/history/hotel/${hotelId}`,
    amenities: "/hotels/hotel/amenities/",

  },
  venuebookings: {
    list: "/admin-panel/bookings/booking-list",
    export: "/vendors/venues/booking-lists/?export=true",
    stats: "/vendors/venues/bookings/stats/",
    detail: (id) =>
      `/admin-panel/bookings/booking-detail/${id}?booking_type=venue`,
    contract: (id) => `/vendors/venues/bookings/${id}/contract/`,
    invoice: (id) => `/vendors/venues/bookings/${id}/invoice/`,
    proposal: (id) => `/vendors/venues/bookings/${id}/proposal/`,
    markCash: (id) => `/vendors/venues/bookings/${id}/payments/mark-cash/`,
  },
  hotelBooking: {
    bookings: "/admin-panel/bookings/booking-list",
    detail: (id) =>
      `/admin-panel/bookings/booking-detail/${id}?booking_type=hotel`,
  },
  changeRequests: {
    list: "/change-requests/",
    create: "/change-requests/",
    detail: (id) => `/change-requests/${id}/`,
    vendors: "/change-requests/vendors/",
    requestTypes: "/change-requests/request-types/",
    listings: "/change-requests/listings/",
    conversations: (id) => `/change-requests/${id}/conversations/`,
    updateStatus: (id) => `/change-requests/${id}/status/`,
  },

  packagecategory: {
    list: "/admin-panel/packages/package/category/",
    create: "/admin-panel/packages/package/category/",
    update: (id) => `/admin-panel/packages/package/category/${id}/`,
    delete: (id) => `/admin-panel/packages/package/category/${id}/`,
  },

  vendorpackage: {
    list: "/admin-panel/packages/vendors/",
    particularvendor: (id) => `/admin-panel/packages/vendors/${id}/packages/`,
  },
  holidaypackage: {
    list: "/vendors/packages/package/",
    detail: (id) => `/vendors/packages/package/${id}/`,
    cards: "/vendors/packages/package/overview/",
    categories: "/admin-panel/packages/package/category/",
    delete: (id) => `/vendors/packages/package/${id}/`,
    city: "/hotels/hotel/city/suggestion/",
    roomsdropdown: "/hotels/hotel/room-dropdown/",
    flightairport: "/flights/airports",
    airline: "/admin-panel/price-lock/airlines",
    create: "/vendors/packages/package/",
    update: (id) => `/vendors/packages/package/${id}/`,
    changestatus: (id) => `/vendors/packages/package/${id}/status/`,
    changepermission:"/admin-panel/packages/package/approve-reject/"
  },
};

export default endpoints;
